import { DocumentEditorPage } from '@jarvis/platform-ui';

export function WordEditorPage() {
  return <DocumentEditorPage mode="edit" kind="richedit" filesLinkTo="/files" filesLinkLabel="Files" />;
}
